// custom-recently-viewed.js

(function() {
  const RECENTLY_VIEWED_KEY = 'recentlyViewedProducts';
  const MAX_RECENTLY_VIEWED = 8; // Change as needed

  function getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecentlyViewed(handle) {
    if (!handle) return;
    let viewed = getRecentlyViewed();
    viewed = viewed.filter(h => h !== handle);
    viewed.unshift(handle);
    if (viewed.length > MAX_RECENTLY_VIEWED) viewed = viewed.slice(0, MAX_RECENTLY_VIEWED);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
  }

  function fetchRecentlyViewedProducts(handles, containerId) {
  if (!handles.length) return;

  const sectionUrl = `/collections/all?section_id=recently-viewed-products-template--custom&handles=${handles.join(',')}`;

  fetch(sectionUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const productsHtml = doc.querySelector('.grid--recently-viewed');

      if (productsHtml) {
        const target = document.getElementById(containerId);
        if (target) {
          target.innerHTML = productsHtml.innerHTML;
          target.classList.remove('hidden');

          document.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded', { bubbles: false }));

          // Initialize Flickity hover sliders if available
          const sliders = target.querySelectorAll('[data-hover-slider]');
          sliders.forEach(slider => {
            if (!slider.classList.contains('flickity-enabled')) {
              new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                wrapAround: true,
                prevNextButtons: true,
                pageDots: false,
                draggable: false,
                fade: true
              });
            }
          });
        }
      }
    })
    .catch(err => console.error('Recently viewed fetch failed', err));
}

  document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('recently-viewed');
    if (!container) return;

    const productHandle = container.getAttribute('data-product-handle');
    const containerId = container.getAttribute('data-wrapper-id');
    const limit = parseInt(container.getAttribute('data-limit') || '4', 10);

    if (productHandle) {
      saveRecentlyViewed(productHandle);
    }

    const viewedHandles = getRecentlyViewed().filter(h => h !== productHandle).slice(0, limit);

    if (viewedHandles.length) {
      fetchRecentlyViewedProducts(viewedHandles, containerId);
    }
  });
})();
